<template>
  <div class="hkl-description-pencil-input">
    <PencilEdit
      v-if="canEdit"
      ref="modal"
      :canEdit="true"
      :displayValue="value || defaultHint"
      @dblclick="() => open()"
      @open="onOpen"
      @close="onClose"
    >
      <HKLInput
        v-model="inputData"
        v-focus
        @keydown.enter="close"
      />
    </PencilEdit>
    <div
      v-else
      class="field__display"
    >
      {{ value || defaultValue }}
    </div>
  </div>
</template>

<script>
import { ref, unref } from 'vue-demi'
import PencilEdit from '@/controls/PencilEdit/index.vue'
import HKLInput from '@/controls/Input/HKLInput'
import { useRefModal } from '@/controls/Modal/modal.hook'
import i18n from '@/utils/i18n'

/**
 * @type {import('vue').Component}
 */
export default {
  components: {
    PencilEdit,
    HKLInput,
  },
  props: {
    value: {
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    defaultHint: {
      type: String,
      default: () => i18n.t('project.docs.fillDescHint'),
    },
    defaultValue: {
      default: '',
    },
  },
  setup (props, { emit }) {
    const { modal, open, close } = useRefModal()
    const inputData = ref('')
    return {
      inputData,
      modal,
      open,
      close,
      onOpen () {
        inputData.value = props.value || props.defaultValue
        emit(open.name)
      },
      onClose () {
        emit(close.name, unref(inputData))
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.hkl-description-pencil-input ::v-deep {
  .field__display {
    font-size: 12px;
    word-break: break-word;
  }
  .field__edit {
    width: 100%;
  }
  .field__display-text, .hkl-input-box {
    font-size: 12px;
  }
  .hkl-input-box {
    height: 36px;
  }
}
</style>
